import './NavItems.scss';
import { Nav, OverlayTrigger, Tooltip } from 'react-bootstrap';
import FeatherIcon from 'components/base/FeatherIcon';
import ThemeToggler from 'components/common/ThemeToggler';
import LoggedInUser from './LoggedInUser';
import LanguageSwitcher from 'components/locales/LanguageSwitcher';
import UserSettingsModal from 'components/user-settings/UserSettingsModal';
import DocsBookIcon from './DocsBookIcon';
import NavbarBrandingImage from './NavbarBrandingImage';

const NavItems = () => {
  return (
    <div className="navbar-nav navbar-nav-icons navbar-nav-icons-custom flex-row">
      <Nav.Item>
        <LoggedInUser />
      </Nav.Item>

      <Nav.Item>
        <LanguageSwitcher />
      </Nav.Item>

      <Nav.Item>
        <UserSettingsModal />
      </Nav.Item>

      <Nav.Item>
        <OverlayTrigger
          placement="bottom"
          overlay={
            <Tooltip id="docs-tooltip" style={{ position: 'fixed' }}>
              Documentation
            </Tooltip>
          }
        >
          <div className="nav-icon-circle nav-icon-circle--green" onClick={() => window.open('/docs/what-is-new.html', 'norscom-docs')}>
            <DocsBookIcon />
          </div>
        </OverlayTrigger>
      </Nav.Item>

      <Nav.Item>
        <ThemeToggler />
      </Nav.Item>

      <Nav.Item>
        <OverlayTrigger
          placement="bottom"
          overlay={
            <Tooltip id="logout-tooltip" style={{ position: 'fixed' }}>
              Sign out
            </Tooltip>
          }
        >
          <div className="nav-icon-circle nav-icon-circle--grey" onClick={() => (window.location.href = '/logoff')}>
            <FeatherIcon icon="log-out" size={16} />
          </div>
        </OverlayTrigger>
      </Nav.Item>

      <NavbarBrandingImage />
    </div>
  );
};

export default NavItems;
